import {
  Box,
  Checkbox,
  FormControlLabel,
  Link,
  Stack,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSignup } from '../SignupContext';

const checkboxSx = {
  alignItems: 'flex-start',
  ml: 0,
  mr: 0,
  '& .MuiCheckbox-root': {
    color: 'var(--dust)',
    padding: '9px 12px 9px 9px',
    '&.Mui-checked': { color: 'var(--sun-deep)' },
  },
  '& .MuiFormControlLabel-label': {
    fontFamily: '"Plus Jakarta Sans Variable", sans-serif',
    fontSize: '0.95rem',
    color: 'var(--ink)',
    lineHeight: 1.55,
    pt: 1,
  },
};

const linkSx = {
  color: 'var(--ink)',
  textDecorationColor: 'var(--sun)',
  textUnderlineOffset: '4px',
  '&:hover': { color: 'var(--sun-deep)' },
};

export default function StepTerminiPrivacy() {
  const { state, update } = useSignup();
  const { t } = useTranslation('signup');
  const { t: tCommon } = useTranslation('common');

  return (
    <Stack spacing={4}>
      <Box>
        <Typography
          variant="h2"
          sx={{
            fontFamily: '"Fraunces Variable", Georgia, serif',
            fontSize: { xs: '2.4rem', md: '3.2rem' },
            letterSpacing: '-0.02em',
            lineHeight: 1,
            mb: 2,
          }}
        >
          {t('step_termini.titolo')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ color: 'var(--ink-soft)', maxWidth: 540, fontSize: '1.05rem' }}
        >
          {t('step_termini.descrizione')}
        </Typography>
      </Box>

      <Stack spacing={2.5}>
        <FormControlLabel
          control={
            <Checkbox
              checked={state.accettato_termini ?? false}
              onChange={(e) =>
                update({ accettato_termini: e.target.checked })
              }
            />
          }
          label={
            <span>
              {t('step_termini.accetto_termini_pre')}
              <Link href="/termini" target="_blank" rel="noopener" sx={linkSx}>
                {t('step_termini.accetto_termini_link')}
              </Link>{' '}
              <Box
                component="span"
                sx={{
                  fontFamily: '"JetBrains Mono Variable", monospace',
                  fontSize: '0.7rem',
                  letterSpacing: '0.08em',
                  textTransform: 'uppercase',
                  color: 'var(--sun-deep)',
                  ml: 1,
                }}
              >
                {tCommon('richiesto')}
              </Box>
            </span>
          }
          sx={checkboxSx}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={state.accettato_privacy ?? false}
              onChange={(e) =>
                update({ accettato_privacy: e.target.checked })
              }
            />
          }
          label={
            <span>
              {t('step_termini.accetto_privacy_pre')}
              <Link href="/privacy" target="_blank" rel="noopener" sx={linkSx}>
                {t('step_termini.accetto_privacy_link')}
              </Link>{' '}
              <Box
                component="span"
                sx={{
                  fontFamily: '"JetBrains Mono Variable", monospace',
                  fontSize: '0.7rem',
                  letterSpacing: '0.08em',
                  textTransform: 'uppercase',
                  color: 'var(--sun-deep)',
                  ml: 1,
                }}
              >
                {tCommon('richiesto')}
              </Box>
            </span>
          }
          sx={checkboxSx}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={state.accettato_marketing ?? false}
              onChange={(e) =>
                update({ accettato_marketing: e.target.checked })
              }
            />
          }
          label={t('step_termini.accetto_marketing')}
          sx={checkboxSx}
        />
      </Stack>
    </Stack>
  );
}
